import * as CryptoJS from 'crypto-js';
import { v4 as uuid4 } from 'uuid';
import * as forge from 'node-forge';

// tslint: disable-next-line: max-classes-per-file
class EncryptedBase
{
    private static PRIVATE_KEY: string;

    constructor(rsaKey: string)
    {
        EncryptedBase.PRIVATE_KEY = rsaKey;
    }

    protected encrypt(msg: string): any
    {
        // Convert PEM key to forge public key
        const publicKey = forge.pki.publicKeyFromPem(EncryptedBase.PRIVATE_KEY);

        // Encrypt using RSA-OAEP with SHA-256
        const encrypted = publicKey.encrypt(msg, 'RSA-OAEP', {
            md: forge.md.sha256.create(),
            mgf1: {
                md: forge.md.sha256.create()
            }
        });

        // Convert to base64
        return forge.util.encode64(encrypted);
    }
}

export class LoginEncrypted extends EncryptedBase
{
    public email: string;
    public password: string;
    public username: string;
    public secretcode: string;
    public code: string;
    public configureForInternal?: boolean;
    public applicationName: string;
    public ip?: string;
    public latitude?: number;
    public longitude?: number;
    public city?: string;
    public country?: string;
    public region?: string;
    public timezone?: string;

    constructor(email: string, password: string, username: string, code: string, rsaKey: string, configureForInternal?: boolean, geolocationData?: {
        ip?: string;
        latitude?: number;
        longitude?: number;
        city?: string;
        country?: string;
        region?: string;
        timezone?: string;
    })
    {
        super(rsaKey);
        this.email = email;
        this.username = username;
        this.password = this.encrypt(password);
        this.code = code;
        this.secretcode = code;
        this.configureForInternal = configureForInternal;
        this.applicationName = 'MIDAS_WEB';
        if (geolocationData) {
            this.ip = geolocationData.ip;
            this.latitude = geolocationData.latitude;
            this.longitude = geolocationData.longitude;
            this.city = geolocationData.city;
            this.country = geolocationData.country;
            this.region = geolocationData.region;
            this.timezone = geolocationData.timezone;
        }
    }
}

export class TransactionPasswordEncrypted extends EncryptedBase
{
    public password: string;

    constructor(password: string, rsaKey: string)
    {
        super(rsaKey);
        this.password = this.encrypt(password);
    }
}

export class AesKeyEncrypted extends EncryptedBase
{
    public aesKey: string;

    constructor(aesKey: string, rsaKey: string)
    {
        super(rsaKey);
        this.aesKey = this.encrypt(aesKey);;
    }
}

export interface IPayloadEncrypted 
{
    /*
    * Key randomically generated and encripted by RSA
    */
    param0: string;

    /*
    * Payload encripted by AES using the decripted key above
    */
    param1: string;
}

/*
* This class receives a request payload and encrypts it using AES e RSA systems
*/
export class PayloadEncrypted 
{
    public payload: IPayloadEncrypted;

    constructor(request: any, rsaKey: string)
    {
        const aesKey: string = uuid4();

        //Encripts payload using AES + key above
        const encryptedMessage = CryptoJS.AES.encrypt(JSON.stringify(request), aesKey).toString();

        //Encripts key using RSA
        const encryptedKey : AesKeyEncrypted = new AesKeyEncrypted(aesKey, rsaKey);
   
        this.payload = {
            param0: encryptedKey.aesKey,
            param1: encryptedMessage
        }
    }
}